import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { v4 as uuid } from 'uuid'
import { enqueueSnackbar } from '../../../store/project/enqueueSnackbar'
import { removeSnackbar } from '../../../store/project/removeSnackbar'
import { Button } from '@material-ui/core'

export function useNotify() {
  const dispatch = useDispatch()

  const addStaticNotify = useCallback((message, type = 'success', action, options = {}) => {
    console.log('Notify:', { message, type, action, options })
    const notifyKey = uuid()
    if (action && action.text && action.key && action.handler) {
      const { text, key, handler } = action
      dispatch(
        enqueueSnackbar({
          key: notifyKey,
          message,
          type,
          action: (
            <Button
              key={key}
              color="secondary"
              size="small"
              onClick={(event) => {
                dispatch(removeSnackbar(notifyKey))
                handler && handler(event)
              }}
              style={{ color: '#fff', textDecoration: 'underline' }}>
              {text}
            </Button>
          ),
          options,
        })
      )
    } else {
      dispatch(
        enqueueSnackbar({
          key: notifyKey,
          message,
          type,
          action,
          options,
        })
      )
    }
    if (!options.disableAutoHide) {
      setTimeout(() => dispatch(removeSnackbar(notifyKey)), 6000)
    }
    return notifyKey
  }, [])

  return {
    notify: addStaticNotify,
  }
}
